<template>
  <BaseChart
    :chart-data="chartData"
    :chart-options="getChartOptions"
  />
</template>

<script>
import BaseChart from './BaseChart.vue';

export default {
  name: 'SplineChart',
  components: { BaseChart },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  computed: {
    getChartOptions () {
      return {
        axisX: {
          valueFormatString: 'DD/MM/YYYY',
          labelFontSize: 12,
          labelAngle: 45
        },
        axisY: {
          title: this.chartData.title,
          titleFontSize: 12,
          includeZero: true,
          interval: 1,
          gridColor: '#ddd'
        },
        data: [{
          type: 'spline',
          markerSize: 5,
          toolTipContent: '{x}: {y}',
          xValueType: 'dateTime',
          color: this.chartData.pointsColor || null,
          lineColor: this.chartData.lineColor || null,
          dataPoints: this.chartData.values?.map(item => ({
            x: new Date(item.date),
            y: item.count
          })) || []
        }]
      };
    }
  }
};
</script>
